// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileFilledSvg from "@fishx/icons-svg/es/asn/FileFilled";
import FishxIcon from '../components/FishxIcon';

var FileFilled = function FileFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileFilledSvg
  }));
};

FileFilled.displayName = 'FileFilled';
export default React.forwardRef(FileFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileFilled.js
// module id = 2701
// module chunks = 0